import React from 'react';
import { Badge } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { getStatementFlagCopy, StatementFlagParams } from 'domain/statement';

const getCopy = copyFor('billing.dashboard.billingHistory.badge');

interface Props {
  statement: StatementFlagParams;
  margin?: Margin;
}

export const StatementBadge = ({ statement, margin }: Props) => {
  const copy = getStatementFlagCopy({ statement, getCopy });
  if (!copy) return null;
  return (
    <Badge
      backgroundColor="warning"
      margin={margin}
      data-testid="statement-badge"
    >
      {copy}
    </Badge>
  );
};
